import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import {FormGroup, Input, Label} from "reactstrap"

class GhtkAddress extends Component {

    _handleChangeInput = (e) => {
        const {type, checked, name} = e.target
        const value = type === 'checkbox' ? checked : e.target.value
        const {onChangeInput} = this.props

        if (typeof onChangeInput === 'function') {
            onChangeInput(name, value)
        }
    }

    _handleChangeInputCod = (e) => {
        const {type, checked, name} = e.target
        const value = type === 'checkbox' ? checked : e.target.value
        const {onChangeInputCod} = this.props

        if (typeof onChangeInputCod === 'function') {
            onChangeInputCod(name, value)
        }
    }

    render() {
        const {item} = this.props
        const {orderNumber, name, address1, country, phone, shipment_info} = item

        return (
            <Fragment>
                <FormGroup>
                    <Label>Order Number</Label>
                    <Input name='orderNumber' value={orderNumber} onChange={this._handleChangeInput}/>
                </FormGroup>
                <FormGroup>
                    <Label>Name</Label>
                    <Input name='name' value={name} onChange={this._handleChangeInput}/>
                </FormGroup>
                <FormGroup>
                    <Label>Address1</Label>
                    <Input name='address1' value={address1} onChange={this._handleChangeInput}/>
                </FormGroup>
                <FormGroup>
                    <Label>Street</Label>
                    <Input name='street' value={shipment_info.street}
                           onChange={this._handleChangeInputCod}/>
                </FormGroup>
                <FormGroup>
                    <Label>Ward</Label>
                    <Input name='ward' value={shipment_info.ward} onChange={this._handleChangeInputCod}/>
                </FormGroup>
                <FormGroup>
                    <Label>District</Label>
                    <Input name='district' value={shipment_info.district}
                           onChange={this._handleChangeInputCod}/>
                </FormGroup>
                <FormGroup>
                    <Label>Province/City</Label>
                    <Input name='province' value={shipment_info.province}
                           onChange={this._handleChangeInputCod}/>
                </FormGroup>
                <FormGroup>
                    <Label>Country</Label>
                    <Input name='country' value={country} onChange={this._handleChangeInput}/>
                </FormGroup>
                <FormGroup>
                    <Label>Phone</Label>
                    <Input name='phone' value={phone} onChange={this._handleChangeInput}/>
                </FormGroup>
            </Fragment>
        )
    }
}

GhtkAddress.propTypes = {
    item: PropTypes.object.isRequired,
    onChangeInput: PropTypes.func.isRequired,
    onChangeInputCod: PropTypes.func.isRequired
}

export default GhtkAddress
